import { observable, IObservableArray, flow, toJS } from 'mobx';
import API from 'api';
import PrescriberPractice from 'stores/PrescriberPractice';

export default class AccountPrescriberPractice {
	@observable id: number;
	@observable accountID: number;
	@observable prescriberPracticeID: number;
	@observable modified: string;
	@observable created: string;
	@observable disabled: boolean = false;
	@observable isDeleted: boolean = false;
	@observable PrescriberPractice: PrescriberPractice = new PrescriberPractice();

	constructor(data: AccountPrescriberPractice) {
		this.extend(data);
	}

	extend(data: JSON) {
		Object.assign(this, data);
	}

	update = flow(function*(withData) {
		if (withData) this.extend(withData);
		this.modified = new Date();
		let res = [];
		if (!this.id) {
			const filters = [
				{ accountID: this.accountID },
				{ prescriberPracticeID: this.prescriberPracticeID }
			];
			const whereFilter = { and: filters };
			res = yield API.get(
				`/AccountPrescriberPractices?filter=${JSON.stringify({
					where: whereFilter
				})}`
			);
		}

		if (this.id || res?.length === 1) {
			// Update record
			const id = this.id ? this.id : res[0].id;
			yield API.patch(`/AccountPrescriberPractices/${id}`, toJS(this));
		} else {
			// New record
			this.created = new Date();
			let result = yield API.post(`/AccountPrescriberPractices`, toJS(this));
			this.id = result.id;
		}
	});
}



// WEBPACK FOOTER //
// ./src/stores/AccountPrescriberPractice.js